<template>
  <div class="wrapper-login">
    <div class="form">
        <div class="content">
            <div class="logo">
                <img src="@/assets/images/logo.png" class="img-fluid" alt="">
            </div>
            <form name="form" @submit.prevent="handleLogin">
                <div class="form-group">
                    <vs-input label="Correo Electrónico" v-model.trim="username"/>
                </div>
                <div class="form-group">
                  <vs-input type="password" label="Contraseña" v-model="password" @keyup.enter="handleLogin"/>
                  <a href="javascript:void(0)" class="forgtoPass" @click="activeRecovery = true">¿Olvidaste la contraseña?</a>
                </div>
                <div class="form-group">
                    <vs-button :disabled="loading" color="primary" @click="handleLogin" id="btnConfirm" type="filled" class="vs-con-loading__container">Ingresar</vs-button>
                    <vs-alert title="Información" active="true" color="danger" v-if="message !== ''">{{ message }}
                    </vs-alert>
                </div>
            </form>
        </div>
    </div>
    <vs-prompt title="¿Olvidaste la contraseña?" accept-text="Aceptar" cancel-text="Cancelar"
      @accept="acceptRecovery"
      @close="closedModaRecovery"
      @cancel="closedModaRecovery"
      :is-valid="email != ''"
      :active="activeRecovery" :buttons-hidden="buttonsHidden">
      <div class="recovery form">
        <div class="form-input">
          <p>Por favor ingresar el Correo Electrónico registrado, para reestablecer tu contraseña</p>
        </div>
        <vs-input placeholder="Correo Electrónico" v-model="email"/>
        <br v-if="buttonsHidden">
        <p v-if="buttonsHidden">Procesando.. Espero un momento</p>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import UserDataService from "@/services/UserDataService"

export default {
  data () {
    return {
      message: "",
      username: "",
      password: "",
      loading: false,
      activeRecovery: false,
      buttonsHidden: false,
      email: ''
    }
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  beforeMount() {
    if (this.userInfoData != null) {
      this.$router.push('/');
    }
  },
  methods: {
    ...mapActions([
      'addUserInfo',
      'companyInfoData'
    ]),
    loadingProgress (_container, _background = '#1a426d', _color = "#fff") {
        this.$vs.loading({
            background: _background,
            color: _color,
            container: _container,
            scale: 0.45
        })
    },
    handleLogin() {
        this.loading = true;
        this.loadingProgress('#btnConfirm')
        if (this.username && this.password) {
            this.$store.dispatch('auth/login', { email: this.username, password: this.password}).then(
              (response) => {
                localStorage.removeItem('readNew');
                localStorage.removeItem('readNew2');
                console.log(response)
                this.addUserInfo({
                  email: response.info.email, 
                  name:  response.info.name,
                  lastName:  response.info.lastname,
                  role:  response.info.role,
                  boxkey: response.token,
                  profileUrl: response.info.profileUrl,
                  welcomeMessage: response.info.welcomeMessage,
                  customerType : response.customer  != undefined ? response.customer.typecode : null, 
                  customer: response.customer  != undefined ? response.customer : null 
                })
                this.$router.push('/');
              },
              error => {
                this.loading = false;
                console.log(error)
                this.message = "Usuario o contraseña invalido!"
                this.$vs.loading.close('#btnConfirm .con-vs-loading')
              }
            );

        } else {
          this.loading = false
          const that   = this
          this.message = "Todos los campos son obligatorios"
          setTimeout(function(){
            that.message = ''
            that.$vs.loading.close('#btnConfirm .con-vs-loading')
          },2000)
        }
    },
    closedModaRecovery(){
      this.activeRecovery = false
      this.buttonsHidden = false
      this.email = ''
    },
    acceptRecovery(){
      this.buttonsHidden = true
      UserDataService.resetPassword({ email: this.email})
        .then(response => {
          this.confirmStatus = false
          console.log(response)
          this.email = ""
          this.activeRecovery = false
          this.buttonsHidden = false
          this.$vs.notify({title:'Información!',text:'<p><b>Hemos enviado la información requerida al correo!<br>(Revisar bandeja de Spam)</b></p>',color:'#068922',icon:'check', time:11000})
        })
        .catch(e => {
            console.log(e)
            this.confirmStatus = false
            this.activeRecovery = false
            this.buttonsHidden = false
            this.$vs.notify({title:'Información!',text:'Error, Reset PWD 001',color:'danger',icon:'error_outline'})                
        });
    }
  }
};
</script>
